import { jsx as r, jsxs as o } from "react/jsx-runtime";
import { tv as i } from "tailwind-variants";
import n from "./NavLinks.js";
const l = i({
  slots: {
    wrapper: [
      "bg-neutral-50",
      "border-b",
      "border-neutral-200",
      "border-t",
      "px-5"
    ]
  },
  variants: {
    isSticky: {
      true: {
        wrapper: ["sticky", "top-[-1px]", "z-20"]
      }
    }
  }
}), { wrapper: d } = l(), p = ({ className: a, children: e, heading: s, isSticky: t }) => /* @__PURE__ */ r("div", { className: d({ class: a, isSticky: t }), children: /* @__PURE__ */ o("div", { className: "container-full flex", children: [
  /* @__PURE__ */ r(
    "span",
    {
      "aria-hidden": "true",
      className: "border-l border-neutral-200 border-r flex items-center font-bold font-secondary tracking-wider px-5 py-3 uppercase",
      children: s
    }
  ),
  e && /* @__PURE__ */ r("div", { className: "min-w-0 ml-auto", children: e })
] }) });
p.NavLinks = n;
export {
  p as default
};
